const RESPONSE_CHOOSE_CAR = 'RESPONSE_CHOOSE_CAR'
const CLEAR_CHOOSE_CAR = 'CLEAR_CHOOSE_CAR'

const chooseCar = (data) => {
  return {
    type: RESPONSE_CHOOSE_CAR,
    data,
  }
}

const clearChoosedCar = () => {
  return {
    type: CLEAR_CHOOSE_CAR,
  }
}

export {
  chooseCar,
  RESPONSE_CHOOSE_CAR,

  clearChoosedCar,
  CLEAR_CHOOSE_CAR,
}
